module.exports = "https://coursera_assets.s3.amazonaws.com/images/9c2f25159f22810cef02471453e2a6f5.svg";